var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.567,16.24,16.1,2.8C15.1.992,13.708,0,12.18,0S9.263.992,8.26,2.8L.793,16.24A4.62,4.62,0,0,0,.5,20.9,4.593,4.593,0,0,0,4.713,22.9H19.647A4.593,4.593,0,0,0,23.858,20.9,4.619,4.619,0,0,0,23.567,16.24ZM11.3,8.167a.875.875,0,0,1,1.75,0V14a.875.875,0,0,1-1.75,0Zm1.7,10.162-.175.14a.883.883,0,0,1-.21.1.7.7,0,0,1-.222.07,1.429,1.429,0,0,1-.222.023,1.753,1.753,0,0,1-.233-.023.741.741,0,0,1-.21-.07.883.883,0,0,1-.21-.1l-.175-.14a1.183,1.183,0,0,1,0-1.657l.175-.14a.883.883,0,0,1,.21-.1.741.741,0,0,1,.21-.07,1,1,0,0,1,.455,0,.7.7,0,0,1,.222.07.883.883,0,0,1,.21.1l.175.14a1.183,1.183,0,0,1,0,1.657Z",
    transform: "translate(1.82 2.333)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.e469a1e110d7acc3c86da6a618aa4217.svg";
export { ForwardRef as ReactComponent };